import React, { createContext } from 'react';

import { Offchain } from 'impermax-sdk';

import { useChainId, useNetworkName } from '../hooks/useNetwork';
import { WHITELISTED_PAIRS } from '../utils/constants';

export interface OffchainContextI {
    offchainInstance?: Offchain;
}

export const OffchainContext = createContext<OffchainContextI>({});

export const OffchainProvider = ({ children }) => {
    const network = useNetworkName();
    const chainId = useChainId();

    return (
        <OffchainContext.Provider
            value={{
                offchainInstance: new Offchain({
                    network,
                    chainId,
                    whitelistedPairs: WHITELISTED_PAIRS[network],
                }),
            }}
        >
            {children}
        </OffchainContext.Provider>
    );
};
